import { useEffect, useRef } from "react";

export const useScanner = (onScanCompleted: (data: string) => void,
                           isEnabled: boolean = true,
) => {
    const bufferRef = useRef("");
    const timeoutRef = useRef<number | null>(null);
    const TIMEOUT_MS = 2000;

    const onKeyDown = (e: KeyboardEvent) => {
        if (!isEnabled) {
            return;
        }

        if (e.key.length !== 1 && e.key !== "Enter") {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (e.key === "Enter") {
            if (bufferRef.current.length > 0) {
                onScanCompleted(bufferRef.current);
                bufferRef.current = "";
            }

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            return;
        }

        bufferRef.current += e.key;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = window.setTimeout(() => {
            bufferRef.current = "";
        }, TIMEOUT_MS);
    };

    useEffect(() => {
        if (!isEnabled) {
            return;
        }

        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isEnabled, onScanCompleted]);
};
